
export default {
  name: 'PagesAboutExtentionsBusinessIntro',
  data() {
    return {
      colors: [
        '#eb5757',
        '#2d9cdb',
        '#f2994a',
        '#27ae60',
        '#bb6bd9',
        '#f2c94c',
        '#c0ca33',
        '#dd2c00',
      ],
    }
  },
  computed: {
    modules() {
      const modules = this.$store.getters['settings/getModules']
      const f = this.$store?.getters['settings/getServicesByModuleId']

      return modules.filter((module) => f(module._id)?.length)
    },
  },
}
